<template>
  <div class="absolute inset-y-0 left-0 pt-6 pl-3" style="height: 300px">
    <div
      class="group flex items-center cursor-pointer mt-2"
      @click="showControlMap = !showControlMap, showFilterProject = false"
    >
      <div
        v-bind:class="
          showControlMap
            ? 'bg-red-500 group-hover:bg-cdmx-red'
            : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'
        "
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current text-gray-100"
          viewBox="0 0 22 22"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
          />
        </svg>
      </div>
      <div
        v-bind:class="showControlMap ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >
        Tipo de mapa
      </div>
    </div>
    <control-map
      :showing="showControlMap"
      @click="changeMapLayer"
    ></control-map>

    <div
      class="group flex items-center cursor-pointer mt-2"
      @click="showFilterProject = !showFilterProject, showControlMap = false"
    >
      <div
        v-bind:class="
          showFilterProject
            ? 'bg-red-500 group-hover:bg-cdmx-red'
            : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'
        "
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current text-gray-100"
          viewBox="0 0 24 24"
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          />
        </svg>
      </div>
      <div
        v-bind:class="showFilterProject ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >
        Filtrar proyectos
      </div>
    </div>
    <filter-explorer
      :showing="showFilterProject"
      @click="updateProjects"
    ></filter-explorer>
  </div>
</template>
<script>
import controlMap from "./ControlMap";
import filterExplorer from "./ExplorerFilterList";

export default {
  name: "ExplorerFilter",
  data() {
    return {
      showControlMap: false,
      showFilterProject: false
    };
  },
  mounted() {},
  components: {
    controlMap,
    filterExplorer
  },
  methods: {
    changeMapLayer(map) {
      console.log("changeMapLayer")
      this.$emit("click", map);
    },
    updateProjects(levantamientos) {
      console.log("updateProjects")
      this.showFilterProject=true;
      this.$emit("updateProjects", levantamientos);
    },
  },
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
